import { useState } from 'react';
import { creatorsByName } from '../lib/catalog';

interface CreatorAvatarProps {
  name: string;
  className?: string;
}

function creatorInitials(name: string): string {
  const parts = name.split(/[^a-z0-9]+/i).filter(Boolean);
  return parts.length > 1
    ? parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase()
    : (parts[0] ?? 'RP').slice(0, 2).toUpperCase();
}

export function CreatorAvatar({ name, className = '' }: CreatorAvatarProps) {
  const avatarUrl = creatorsByName.get(name)?.avatarUrl;
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  return avatarUrl && avatarUrl !== failedUrl
    ? <img className={`creator-avatar ${className}`} src={avatarUrl} alt={`${name} avatar`} loading="lazy" decoding="async" onError={() => setFailedUrl(avatarUrl)} />
    : <span className={`creator-avatar creator-avatar-fallback ${className}`} role="img" aria-label={`${name} avatar`}>{creatorInitials(name)}</span>;
}
